// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AdminCustomProperty } from './admin-custom-property';
import { CustomPropertyType } from './custom-property-type';
import { Lookup } from './lookup';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CustomProperty extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  customPropertyId!: number;
  adminTypeId?: number;
  createdBy!: string;
  createdDate!: Date;
  customPropertyTypeId!: number;
  dateFrom?: Date;
  dateTo?: Date;
  flags?: number;
  lookupId?: number;
  propertyValue?: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  value?: number;
  value1?: number;
  adminCustomProperties!: AdminCustomProperty[];
  customPropertyType!: CustomPropertyType;
  lookup!: Lookup;
}

